document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('modal');
  const openBtn = document.querySelectorAll('.modal-trigger');
  const closeBtn = document.getElementById('closeModalBtn');
  const tabs = document.querySelectorAll('.tab');
  const nativeLoginPage = document.querySelector('.template-customers-login');
  const recoverPasswordPage = document.querySelector('#recover-password');
  const nativeRegisterPage = document.querySelector('.template-customers-register');

  const tabContents = {
    join: document.getElementById('join-tab'),
    signin: document.getElementById('signin-tab'),
  };

  function toggleModal(show) {
    modal.style.display = show ? 'block' : 'none';
  }

  // Delegated so dynamically-added triggers (e.g. the cloned mobile nav drawer) also open the modal
  document.addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('.modal-trigger')) {
      e.preventDefault();
      toggleModal(true);
    }
  });
  closeBtn.addEventListener('click', () => {
    toggleModal(false)
    if((!!nativeLoginPage && recoverPasswordPage.checkVisibility() === false) || !!nativeRegisterPage) {
      window.location.href = "/"
    }
  });
  window.addEventListener('click', (e) => {
    if (e.target === modal) toggleModal(false);
  });

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      Object.values(tabContents).forEach(el => el.classList.add('hidden'));
      tab.classList.add('active');
      tabContents[tab.dataset.tab].classList.remove('hidden');
    });
  });

  // Utils
  const isEmailValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const showError = (input, errorId, message) => {
    const errorEl = document.getElementById(errorId);
    input.classList.add('invalid');
    errorEl.innerText = message;
    errorEl.style.display = 'block';
  };

  const hideError = (input, errorId) => {
    const errorEl = document.getElementById(errorId);
    input.classList.remove('invalid');
    errorEl.innerText = '';
    errorEl.style.display = 'none';
    const errorBanner = document.querySelector('.error-banner');
    errorBanner.classList.add('hidden');
  };

  const validateSingleField = (input, errorId, message, condition) => {
    if (!condition()) {
      showError(input, errorId, message);
      return false;
    } else {
      hideError(input, errorId);
      return true;
    }
  };

  function toggleButton(button, enable) {
    if (enable) {
      button.disabled = false;
      button.classList.add('enabled');
    } else {
      button.disabled = true;
      button.classList.remove('enabled');
    }
  }

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const registerFields = {
    firstName: {
      input: document.getElementById('registerFirstName'),
      errorId: 'errorRegisterFirstName',
      message: 'Required',
      condition: () => registerFields.firstName.input.value.trim() !== ''
    },
    lastName: {
      input: document.getElementById('registerLastName'),
      errorId: 'errorRegisterLastName',
      message: 'Required',
      condition: () => registerFields.lastName.input.value.trim() !== ''
    },
    // birthdate: {
    //   input: document.getElementById('registerBirthdate'),
    //   errorId: 'errorRegisterBirthdate',
    //   message: 'Required',
    //   condition: () => registerFields.birthdate.input.value.trim() !== ''
    // },
    email: {
      input: document.getElementById('registerEmail'),
      errorId: 'errorRegisterEmail',
      message: 'Please enter a valid email',
      condition: () => isEmailValid(registerFields.email.input.value)
    },
    password: {
      input: document.getElementById('registerPassword'),
      errorId: 'errorRegisterPassword',
      message: 'Must be at least 6 characters',
      condition: () => registerFields.password.input.value.length >= 6
    }
  };
  const registerSubmitBtn = document.getElementById('registerSubmitBtn');

  const signinFields = {
    email: {
      input: document.getElementById('signinEmail'),
      errorId: 'errorSigninEmail',
      message: 'Please enter a valid email',
      condition: () => isEmailValid(signinFields.email.input.value)
    },
    password: {
      input: document.getElementById('signinPassword'),
      errorId: 'errorSigninPassword',
      message: 'Please enter your password',
      condition: () => signinFields.password.input.value.trim() !== ''
    }
  };
  const signinSubmitBtn = document.getElementById('signinSubmitBtn');

  // Register Field Listeners
  Object.entries(registerFields).forEach(([key, { input, errorId, message, condition }]) => {
    input.addEventListener('focus', () => hideError(input, errorId));
    input.addEventListener('blur', () => validateSingleField(input, errorId, message, condition));
    input.addEventListener('input', () => {
      const allValid = Object.values(registerFields).every(f =>
        f.condition()
      );
      toggleButton(registerSubmitBtn, allValid);
    });
  });

  // Signin Field Listeners
  Object.entries(signinFields).forEach(([key, { input, errorId, message, condition }]) => {
    input.addEventListener('focus', () => hideError(input, errorId));
    input.addEventListener('blur', () => validateSingleField(input, errorId, message, condition));
    input.addEventListener('input', () => {
      const allValid = Object.values(signinFields).every(f =>
        f.condition()
      );
      toggleButton(signinSubmitBtn, allValid);
    });
  });

  // Toggle password visibility
  document.querySelectorAll('.toggle-password').forEach(button => {
    button.addEventListener('click', function () {
      const targetId = this.dataset.target;
      const passwordInput = document.getElementById(targetId);
  
      if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        button.classList.remove('eye-close');
        button.classList.add('eye-open')
      } else {
        passwordInput.type = 'password';
        button.classList.remove('eye-open');
        button.classList.add('eye-close')
      }
    });
  });

  
  if(!!nativeLoginPage && recoverPasswordPage.checkVisibility() === false)  {
    nativeLoginPage.querySelector('.login-page').style.visibility = 'hidden';
    toggleModal(true);
    const errorList = document.querySelectorAll('.errors-text .styled-list li');
      if(errorList.length > 0) {
        const errorMsgList = Array.from(errorList).map((errorItem) => {
       return errorItem.textContent.replace(/\n/g, '').trim();
      });
  
      const errorBanner = document.querySelector('#signinForm .error-banner');
      const errorTextContainer = errorBanner.querySelector('.error-banner__message');
      if(errorMsgList.length === 1) {
        errorTextContainer.textContent = errorMsgList[0];
      }
      console.log(errorMsgList.join(','))
      errorBanner.classList.remove('hidden');
    }
  }

  if(!!nativeRegisterPage)  {
    nativeRegisterPage.querySelector('.register-page').style.visibility = 'hidden';
    document.querySelector('[data-tab="join"]').click();
    toggleModal(true);
    const errorList = document.querySelectorAll('.errors-text .styled-list li');
      if(errorList.length > 0) {
        const errorMsgList = Array.from(errorList).map((errorItem) => {
       return errorItem.textContent.replace(/\n/g, '').trim();
      });
  
      const errorBanner = document.querySelector('#registerForm .error-banner');
      const errorTextContainer = errorBanner.querySelector('.error-banner__message');
      if(errorMsgList.length === 1) {
        errorTextContainer.textContent = errorMsgList[0];
      }
      console.log(errorMsgList.join(','))
      errorBanner.classList.remove('hidden');
    }
  }
  function isSafariMobile() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }
  
  if (isSafariMobile()) {
    const birthDateWrapper = document.querySelector('.date-wrapper');
    birthDateWrapper.classList.add('show-placeholder');
  }

  const dateInput = document.querySelector('#registerBirthdate');
  dateInput.addEventListener('input', () => {
    dateInput.classList.toggle('has-value', !!dateInput.value);
  });
});
